var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"metanav"},[(!_vm.viewIsMobile)?_c('Logo'):_vm._e(),_vm._v(" "),_vm._l((_vm.metaNav),function(entry,idx){return _c('NavItem',{key:idx,attrs:{"entry":entry}})}),_vm._v(" "),(!_vm.useRestrictedNavigation)?_c('NavAdmin'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }